import * as React from "react";
import { Box, Button } from "@mui/material";
import MainContext from "../../../context/mainContext";
import srtParser2 from "srt-parser-2";
import { default as toWebVTT } from "srt-webvtt";
import FirstLoginDialog from "./FirstLoginDialog";

export default function StartBox({ handleFullScreen, handlePlayingStatus }) {
  const { videoInfo, handleVideoInfo, handleSubtitleContenet } =
    React.useContext(MainContext);

  const subtitleOneControl = (subtitileOneJson, langOne) => {
    handleSubtitleContenet("One", "");
    if (subtitileOneJson.length == 0) return false;
    let trackOne = document.querySelector("#subtitlesOneTrack");
    trackOne.addEventListener("cuechange", function (e) {
      if (e.target.track.activeCues.length !== 0) {
        handleSubtitleContenet(
          "One",
          subtitileOneJson[e.target.track.activeCues[0].id - 1].text
        );
      } else {
        handleSubtitleContenet("One", "");
      }
    });
  };

  const subtitleTwoControl = (subtitileTwoJson, langTwo) => {
    handleSubtitleContenet("Two", "");
    if (subtitileTwoJson.length == 0) return false;
    let trackTwo = document.querySelector("#subtitlesTwoTrack");
    trackTwo.addEventListener("cuechange", function (e) {
      if (e.target.track.activeCues.length !== 0) {
        handleSubtitleContenet(
          "Two",
          subtitileTwoJson[e.target.track.activeCues[0].id - 1].text
        );
      } else {
        handleSubtitleContenet("Two", "");
      }
    });
  };

  const srtToJson = (file, lang, number) => {
    const reader = new FileReader();
    reader.readAsText(file);
    reader.onload = () => {
      const text = reader.result;
      let parser = new srtParser2();
      let result = parser.fromSrt(text);
      if (number == "one") subtitleOneControl(result, lang);
      if (number == "two") subtitleTwoControl(result, lang);
    };
  };

  const addTrackToVideo = async () => {
    try {
      let video = document.querySelector("#MainVideo video");
      let response1;
      await fetch(`${process.env.REACT_APP_SITEURL}/videoBox/sub1-1-pc.srt`)
        .then((res) => res.blob()) // Gets the response and returns it as a blob
        .then((blob) => {
          response1 = blob;
        });
      let subFile1 = new File([response1], "subone.srt");
      const textTrackUrl1 = await toWebVTT(subFile1);
      let oldTrack1 = document.getElementById("subtitlesOneTrack");
      if (oldTrack1) video.removeChild(oldTrack1);
      let track1 = document.createElement("track");
      track1.kind = "subtitles";
      track1.id = "subtitlesOneTrack";
      track1.src = textTrackUrl1;
      track1.srclang = "en";
      video.appendChild(track1);
      srtToJson(subFile1, "en", "one");

      let response2;
      await fetch(`${process.env.REACT_APP_SITEURL}/videoBox/sub1-2-pc.srt`)
        .then((res) => res.blob()) // Gets the response and returns it as a blob
        .then((blob) => {
          response2 = blob;
        });
      let subFile2 = new File([response2], "subone.srt");
      const textTrackUrl2 = await toWebVTT(subFile2);
      let oldTrack2 = document.getElementById("subtitlesTwoTrack");
      if (oldTrack2) video.removeChild(oldTrack2);
      let track2 = document.createElement("track");
      track2.kind = "subtitles";
      track2.id = "subtitlesTwoTrack";
      track2.src = textTrackUrl2;
      track2.srclang = "fa";
      video.appendChild(track2);
      srtToJson(subFile2, "fa", "two");

      if (video["textTracks"]) {
        for (let i = 0; i < video["textTracks"].length; i++) {
          video.textTracks[i].mode = "hidden";
        }
      }
    } catch (error) {
      console.log("Error in addTrackToVideo", error);
    }
  };

  const startShowClip = () => {
    handleVideoInfo({
      ...videoInfo,
      videoFile: `${process.env.REACT_APP_SITEURL}/video/tutorial/maintutorialpc.mp4`,
    });
    handleFullScreen.enter();
    handlePlayingStatus(true);
    setTimeout(() => {
      addTrackToVideo();
    }, 2000);
  };

  const showHowWorkWithApp = (uri) => {
    handleVideoInfo({
      ...videoInfo,
      videoFile: uri,
    });
    handleFullScreen.enter();
    handlePlayingStatus(true);
  };
  return (
    <Box>
      <FirstLoginDialog startShowClip={startShowClip} />
      <Button
        variant="contained"
        onClick={(e) => {
          showHowWorkWithApp(
            `${process.env.REACT_APP_SITEURL}/video/tutorial/0-main.mp4`
          );
          e.target.blur();
        }}
        color="success"
        sx={{ mx: 1 }}
        // size="small"
      >
        نمیدونم چطور با برنامه کار کنم !
      </Button>
      <Button
        variant="contained"
        onClick={(e) => {
          showHowWorkWithApp(
            `${process.env.REACT_APP_SITEURL}/video/newVideo/101.mp4`
          );
          e.target.blur();
        }}
        color="success"
        sx={{ mx: 1 }}
        size="small"
      >
        اولین قدم: انتخاب فیلم و زیرنویس
      </Button>
    </Box>
  );
}
